import { formatDate } from 'shared/lib/formatters';

export const SET_VISITED = 'SET_VISITED';

export default function reducer(state = {}, action) {
  switch (action.type) {
    case SET_VISITED: {
      return {
        ...state,
        [action.payload.jobId]: new Date().getTime()
      };
    }

    default:
      return state;
  }
}

export const actions = {
  setVisited(jobId) {
    return {
      type: SET_VISITED,
      payload: {
        jobId
      }
    };
  }
};

export const selectors = {
  getVisitedDate(state, jobId) {
    const visitedDate = state.visited[jobId];
    if (state.auth.loggedIn && visitedDate) {
      return formatDate(visitedDate, state.auth.language);
    }

    return null;
  }
};
